import ApiService from './api'

const documentErrorMessages = {
  413: 'O servidor bloqueou o envio do modelo pelo tamanho. O limite de upload do servidor precisa ser ajustado para receber o documento e suas imagens.',
}

const LegalTemplates = {
  convertDocx: async (file, signal) => {
    const body = new FormData()
    body.append('file', file)
    const result = await ApiService.request('modelos-pecas/importar-docx', {
      method: 'POST',
      body,
      responseType: 'blob',
      timeoutMs: 90000,
      signal,
      fallbackErrorMessages: {
        413: 'O servidor recusou o arquivo por exceder o limite de envio. A importação aceita arquivos DOCX de até 10 MB. Se o arquivo estiver dentro desse limite, solicite ao administrador a revisão do limite de upload do servidor.',
        406: 'O servidor não conseguiu processar a importação do DOCX (HTTP 406). Solicite ao administrador a verificação da resposta do servidor e dos registros da importação.',
      },
    })
    let warnings = []
    try {
      const raw = result.headers?.get('X-Legal-Template-Import-Warnings')
      const parsed = raw && JSON.parse(decodeURIComponent(raw))
      if (Array.isArray(parsed))
        warnings = parsed
          .filter((message) => typeof message === 'string')
          .slice(0, 20)
    } catch {
      /* A missing optional notice must not discard a converted document. */
    }
    return { ...result, warnings }
  },
  list: () => ApiService.request('modelos-pecas'),
  areas: () => ApiService.request('modelos-pecas/areas'),
  get: (id) => ApiService.request(`modelos-pecas/${encodeURIComponent(id)}`),
  save: (model) =>
    ApiService.request(
      model.id
        ? `modelos-pecas/${encodeURIComponent(model.id)}`
        : 'modelos-pecas',
      {
        method: model.id ? 'PUT' : 'POST',
        fallbackErrorMessages: documentErrorMessages,
        body: JSON.stringify({
          name: model.name,
          area: model.area,
          description: model.description,
          document: model.document,
          version: model.version,
        }),
      },
    ),
  remove: (model) =>
    ApiService.request(
      `modelos-pecas/${encodeURIComponent(model.id)}?version=${model.version}`,
      { method: 'DELETE' },
    ),
  word: (model) =>
    ApiService.request('modelos-pecas/exportar-docx', {
      method: 'POST',
      responseType: 'blob',
      fallbackErrorMessages: documentErrorMessages,
      body: JSON.stringify({
        name: model.name,
        area: model.area,
        description: model.description,
        document: model.document,
      }),
    }),
}

export default LegalTemplates
